module.exports = __webpack_public_path__ + "img/jlyc.c655388f.png";